import { i18n } from '@/i18n'
import store from '@/store'

export default (params) => {
  const hasModuleAgrupaciones = store.getters['auth/hasAgrupacionesModule']

  const hasAnyPersonalizationModule = store.getters['auth/hasAnyPersonalizationModule']
  const hasModuleXslt = store.getters['auth/hasXsltModule']
  const hasModuleWebHooks = store.getters['auth/hasAnyWebHooksModule']
  const hasModuleADD = store.getters['auth/hasIntegracionAADModule']
  const hasModuleSAML2 = store.getters['auth/hasSAML2Module']
  
  const configGrouping = {
    name: i18n.t('grouping.header'),
    path: 'configurations/grouping/companies',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const configPersonalization = {
    name: i18n.t('personalization.header'),
    path: 'configurations/clients/personalization',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  
  const configPdftemplate = {
    name: i18n.t('plantilla_pdf.header'),
    path: 'configurations/clients/pdftemplate',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  
  const configWebHooks = {
    name: i18n.t('webhooks.header'),
    path: 'configurations/clients/webhooks',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const configAAD = {
    name: i18n.t('configAAD.header'),
    path: 'configurations/clients/configAAD',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const configSAML2 = {
    name: i18n.t('configsaml2.header'),
    path: 'configurations/clients/configSAML2',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }

  const configHistorical = 
  {
    name: i18n.t('historical.entity_name'),
    path: 'configurations/clients/historical',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }

  const menu = [
    {
      icon: 'config',
      name: i18n.t('clients.header'),
      path: 'configurations/clients',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'configurations/clients/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('clients.modules'),
          path: 'configurations/clients/modules',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('clients.template'),
          path: 'configurations/clients/template/companies',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('clients.template_groups'),
          path: 'configurations/clients/template/groups',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
      ]
    }
  ]

  if (hasModuleAgrupaciones) {
    menu[0].sc.push(configGrouping)
  }

  if (hasAnyPersonalizationModule) {
    menu[0].sc.push(configPersonalization)
  }
  if (hasModuleXslt) {
    menu[0].sc.push(configPdftemplate)
  }
  if (hasModuleWebHooks) {
    menu[0].sc.push(configWebHooks)
  }
  if (hasModuleADD) {
    menu[0].sc.push(configAAD)
  }
  if (hasModuleSAML2) {
    menu[0].sc.push(configSAML2)
  }
  menu[0].sc.push(configHistorical)
  return menu
}
